import React, {createContext, useMemo} from 'react';
import {I18nManager} from 'react-native';
import {usePageLocale} from "./usePageLocale";

export const LocaleContext = createContext({});

export const LocaleProvider = ({children}) => {
    const pageName = window.location.href.split('/')[3];
    const pageLocale = usePageLocale({pageName});

    const LocaleContextValue = useMemo(
        () => ({
            ...pageLocale,
            setLayout: () => {
                I18nManager.isRTL = pageLocale.isRtl;
                I18nManager.forceRTL(pageLocale.isRtl);
            }
        }),
        [pageLocale]
    );

    return (
        <LocaleContext.Provider value={LocaleContextValue}>
            {children}
        </LocaleContext.Provider>
    );
};
